import axios from 'axios';
import CONFIG from '../config';

export const getHeaderSliders = (locale) => axios.get(`${CONFIG.API_BASE}/header_sliders`, {
  params: { locale, v: CONFIG.VERSION }
}).then(res => res.data).then(res => {
  const headerSliders = res.data || [];

  return headerSliders.map(slider => ({
    id: slider.id,
    imageDesktop: slider.image_desktop,
    imageMobile: slider.image_mobile,
    title: slider.title,
    description: slider.description,
    ctaText: slider.cta_text,
    ctaLink: slider.cta_link,
    status: slider.status
  }));
});

export const getHeaderSlider = (locale, id) => axios.get(`${CONFIG.API_BASE}/header_sliders/${id}`, {
  params: { locale }
}).then(res => res.data);